// extracted by mini-css-extract-plugin
export default {"segunda-seccion":"estilos_segunda-seccion__T8l0A","marca-agua":"estilos_marca-agua__UsycC","texto":"estilos_texto__eukQi"};